<template>
  <div class="details">
    <div class="top"></div>
    <div class="war-box">
      <h1>{{data.gamename}} <span>{{data.remark}}</span></h1>
      <ul>
        <div class="deta-box">
          <li>
            <div>申报类型</div>

            <span
              :class="[data.declaretype.declaretype =='移动端'?'bqyd':data.declaretype.declaretype == '客户端' ?'bqdn':data.declaretype.declaretype == '浏览器'?'bqllq':'bq']"
              v-if="data.declaretype"
            >{{data.declaretype.name}}</span>
            <div v-else style="color:#ccc">暂无</div>
          </li>
          <li>
            <div>游戏类型</div>
            <div v-if="data.gametype">{{data.gametype}}</div>
            <div v-else style="color:#ccc">暂无</div>
          </li>
        </div>
        <div class="deta-box">
          <li>
            <div>出版单位</div>
            <div v-if="data.pubunitname">{{data.pubunitname}}</div>
            <div v-else style="color:#ccc">暂无</div>
          </li>
          <li>
            <div>著作权人</div>
            <div v-if="data.authorname">{{data.authorname}}</div>
            <div v-else style="color:#ccc">暂无</div>
          </li>
          <li>
            <div>运营单位</div>
            <div v-if="data.saleunit">{{data.saleunit}}</div>
            <div v-else style="color:#ccc">暂无</div>
          </li>
        </div>
        <div class="deta-box">
          <li>
            <div>文号</div>
            <div v-if="data.piwenno">{{data.piwenno}}</div>
            <div v-else style="color:#ccc">暂无</div>
          </li>
          <li>
            <div>出版物号</div>
            <div v-if="data.isbn">{{data.isbn}}</div>
            <div v-else style="color:#ccc">暂无</div>
          </li>
        </div>
        <div class="deta-box">
          <li>
            <div>变更信息</div>
            <div v-if="data.changeinfo">{{data.changeinfo}}</div>
            <!-- <div class="bg" v-if="data.changeinfo">
              <div class="bgxx">
                <span>变更前</span>
                <span>{{data.changeinfo}}</span>
              </div>
              <div class="bgxx">
                <span style="background:rgba(2,163,213,0.1);color:#02A3D5">变更前</span>
                <span style="color:#000">{{data.changeinfo}}</span>
              </div>
            </div>-->
            <div v-else style="color:#ccc">暂无</div>
          </li>
        </div>
        <div class="deta-box">
          <li>
            <div>时间</div>
            <div>{{formdata(data.time)}}</div>
          </li>
        </div>
      </ul>
    </div>
    <div class="loading" v-if="isLoad">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        isLoad: false
      }
    };
  },
  created() {
    this.isLoad = true;
    this.init();
  },
  methods: {
    async init() {
      let parmas = { id: this.$route.query.id };
      let { data } = await this.$http.post(
        "api/Game/GetGameIsbnDataDetail",
        parmas
      );
      var key = data.Data.declaretype;
      data.Data.declaretype = {
        declaretype: "",
        name: key
      };
      if (!key) {
        data.Data.declaretype = "";
      } else if (key.indexOf("PC") != -1 || key.indexOf("客户端") != -1) {
        data.Data.declaretype.declaretype = "客户端";
      } else if (key.indexOf("网页") != -1) {
        data.Data.declaretype.declaretype = "浏览器";
      } else if (key.indexOf("移动") != -1) {
        data.Data.declaretype.declaretype = "移动端";
      } else if (key.indexOf("游戏机") != -1) {
        data.Data.declaretype.declaretype = "游戏机";
      } else {
      }
      this.data = data.Data;

      this.isLoad = false;
    },
    formdata(val) {
      if (val) {
        let arr = val.split("-");
        return `${arr[0]}年${arr[1]}月${arr[2]}日`;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.details {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: scroll;
  background: #f5f6f5;
  .loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 1);
    z-index: 9999;
  }
  .top {
    position: fixed;
    top: 0;
    width: 100%;
    height: 4px;
    background: rgba(2, 163, 213, 1);
  }
  .war-box {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;

    // height: 583px;
    // background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    margin: 0 auto;
    // margin-top: 16px;
    // padding: 0 16px;
    // padding-bottom: 30px;
    // box-sizing: border-box;
    overflow: hidden;
    h1 {
      margin-top: 4px;
      font-size: 20px;
      font-weight: 700;
      color: rgba(0, 0, 0, 1);
      padding: 15px 0;

      span{
        float: right;
        color: red;
        font-weight: 400;
        font-size: 14px;
      }
    }
    .deta-box {
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      padding: 16px;
      box-sizing: border-box;
      margin-bottom: 10px;
      li:nth-child(1) {
        margin-top: 0 !important;
      }
    }
    ul {
      width: 100%;
      li {
        width: 100%;
        margin-top: 15px;
        div:nth-child(1) {
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 21px;
        }
        div:nth-child(2) {
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          line-height: 24px;
          margin-left: 10px;
        }
        .bq {
          display: inline-flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 24px !important;
          align-content: center;
          padding: 0 8px;
          box-sizing: border-box;
          border-radius: 2px;
          font-size: 16px;
          font-weight: 400;
          vertical-align: middle;
          color: rgba(2, 163, 213, 1);
          &::before {
            vertical-align: middle;
            display: inline-block;
            content: "";
            width: 14px;
            margin-right: 2px;
            height: 14px;
            background-image: url("../assets/icon-lb.png");
            background-repeat: no-repeat;
            background-size: 14px 14px;
            background-position: center;
          }
        }
        .bqyd {
          display: inline-flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 24px !important;
          align-content: center;
          padding: 0 8px;
          box-sizing: border-box;
          border-radius: 2px;
          font-size: 16px;
          font-weight: 400;
          vertical-align: middle;
          color: rgba(2, 163, 213, 1);
          &::before {
            vertical-align: middle;
            display: inline-block;
            content: "";
            width: 14px;
            margin-right: 2px;
            height: 14px;
            background-image: url("../assets/icon-ydd.png");
            background-repeat: no-repeat;
            background-size: 14px 14px;
            background-position: center;
          }
        }
        .bqdn {
          display: inline-flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 24px !important;
          align-content: center;
          padding: 0 8px;
          box-sizing: border-box;
          border-radius: 2px;
          font-size: 16px;
          font-weight: 400;
          vertical-align: middle;
          color: rgba(2, 163, 213, 1);
          &::before {
            vertical-align: middle;
            display: inline-block;
            content: "";
            width: 14px;
            margin-right: 2px;
            height: 14px;
            background-image: url("../assets/icon-dn.png");
            background-repeat: no-repeat;
            background-size: 14px 14px;
            background-position: center;
          }
        }
        .bqllq {
          display: inline-flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 24px !important;
          align-content: center;
          padding: 0 8px;
          box-sizing: border-box;
          border-radius: 2px;
          font-size: 16px;
          font-weight: 400;
          vertical-align: middle;
          color: rgba(2, 163, 213, 1);
          &::before {
            vertical-align: middle;
            display: inline-block;
            content: "";
            width: 14px;
            margin-right: 2px;
            height: 14px;
            background-image: url("../assets/icon-lla.png");
            background-repeat: no-repeat;
            background-size: 14px 14px;
            background-position: center;
          }
        }
        // .bq {
        //   display: block;
        //   height: 24px !important;
        //   padding: 0 8px 0 34px;
        //   box-sizing: border-box;
        //   background-image: url("../assets/icon-lb.png");
        //   background-repeat: no-repeat;
        //   background-size: 14px;
        //   background-position: 14px center;
        //   font-size: 16px;
        //   font-weight: 400;
        //   line-height: 26px !important;
        //   color: rgba(2, 163, 213, 1);
        // }
        .bg {
          margin-left: 16px;
        }
        .bgxx {
          height: auto;
          margin-left: 0 !important;
          display: flex;
          flex-direction: row;
          align-items: center;
          flex-wrap: wrap;
          span {
            display: inline-block;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          }
          span:nth-child(1) {
            width: 44px;
            height: 18px;
            background: rgba(204, 204, 204, 0.1);
            border-radius: 2px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(204, 204, 204, 1);
            text-align: center;
          }
          span:nth-child(2) {
            margin-left: 6px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(204, 204, 204, 1);
          }
        }
      }
    }
  }
}
</style>